import __vue_component__ from '../../alerts/Alert.vue.js';
import __vue_component__$1 from '../../alerts/Pane/Pane.vue.js';
import __vue_component__$2 from '../../cards/BasicCard/BasicCard.vue.js';

var SupportedDynamicCopyComponent;
(function (SupportedDynamicCopyComponent) {
    SupportedDynamicCopyComponent["ALERT"] = "Alert";
    SupportedDynamicCopyComponent["PANE"] = "Pane";
    SupportedDynamicCopyComponent["BASIC_CARD"] = "BasicCard";
    SupportedDynamicCopyComponent["DIV"] = "div";
})(SupportedDynamicCopyComponent || (SupportedDynamicCopyComponent = {}));
const DCComponents = {
    [SupportedDynamicCopyComponent.ALERT]: __vue_component__,
    [SupportedDynamicCopyComponent.PANE]: __vue_component__$1,
    [SupportedDynamicCopyComponent.BASIC_CARD]: __vue_component__$2,
    [SupportedDynamicCopyComponent.DIV]: 'div',
};

export { DCComponents, SupportedDynamicCopyComponent };
